<template>
	<section class="view-venue-list">
		<ChalkyVenueCardPreview
			class="list-item"
			v-bind:key="venueModel.id"
			v-bind:maxGalleryImages="$setting('maxGalleryImages', 'venue')"
			v-bind:venueModel="venueModel"
			v-for="venueModel in venueCollection"
			v-on:click.native="Handle_OnClickVenue(venueModel)"
		/>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueList extends ViewBase {
		/**
		 * Collection of venues to display.
		 *
		 * @type ChalkySticks.Collection.Venue
		 */
		@Prop({ required: true })
		public venueCollection!: ChalkySticks.Collection.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle venue card click.
		 *
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return void
		 */
		protected Handle_OnClickVenue(venueModel: ChalkySticks.Model.Venue): void {
			this.$emit('select', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-list {
		background: var(--chalky-blue-2);
		border-radius: 0.5rem;
		display: flex;
		flex-direction: column;
		gap: 1rem;
		margin-left: -0.25rem;
		margin-right: -0.25rem;
		padding: 0.75rem;

		.venue-cardpreview {
			.content {
				--padding: 1rem;
			}

			.actions {
				display: none;
			}

			.name {
				max-width: 100%;
			}

			.utility-dots {
				display: none;
			}
		}
	}
</style>
